export default __webpack_public_path__ + "static/media/attandance.730c9d15.svg";